import axios from "axios";
import { getAPIBaseURL, logout, adminLogout } from "./helpers";
import { captureException } from "../sentry";
/* const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: getAPIBaseURL()
}) */
//axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
axios.defaults.withCredentials = true;

const reportRequestError = (error, method, url) => {
  const status = error?.response?.status
  // Skip expected auth / validation client errors
  if (status && status < 500 && status !== 0) return
  captureException(error, {
    tags: { area: 'api', method },
    extra: {
      url,
      status: status || null,
      data: error?.response?.data || null
    }
  })
}

const handleAuthExpiry = (error) => {
  if (error?.response?.status === 401) {
    const errorMessage = error?.response?.data?.data || error?.response?.data?.message || ''
    if (errorMessage === 'Token expired' || errorMessage.includes('expired')) {
      logout()
      return true
    }
  }
  return false
}

export const postData = async (url, headers, data) => {
  try{
        //alert(JSON.stringify(headers))
        //alert(url)
        //alert(data) 
        const res = await axios.post(url, data, {headers: headers, withCredentials: true});
         //alert(JSON.stringify(res))
          //alert(JSON.stringify(res))
          //alert('response')
          return {error: "", result: res};
            
      }catch(error){
        //alert(JSON.stringify(error))
        // Handle token expiration
        if(handleAuthExpiry(error)){
            return {error: "error", result: error?.response}
        }
        reportRequestError(error, 'POST', url)
        /* if(error?.response?.status == 422){
          window.location.href='/login'
        }
        if(error?.response?.status == 401){
          alert('Invalid details')
        } */
        //alert(JSON.stringify(error?.response))
        return {error: "error", result: error?.response}
      }
}

export const patchData = async (url, headers, data) => {
  try {
    const res = await axios.patch(url, data, { headers: headers, withCredentials: true })
    return { error: '', result: res }
  } catch (error) {
    if (handleAuthExpiry(error)) {
      return { error: 'error', result: error?.response }
    }
    reportRequestError(error, 'PATCH', url)
    return { error: 'error', result: error?.response }
  }
}

export const updateData = async (url, headers, data) => {
  try{
        //alert(JSON.stringify(headers))
         const res = await axios.put(url, data, {headers: headers, withCredentials: true, credentials: 'include'});
          //alert(JSON.stringify(res))
          //alert('response')
          return {error: "", result: res};
            
      }catch(error){
        //alert(JSON.stringify(error.response))
        // Handle token expiration
        if(handleAuthExpiry(error)){
          return {error: "error", result: error?.response}
        }
        reportRequestError(error, 'PUT', url)
        if(error?.response?.status == 422){
          window.location.href='/login'
        }
        return {error: "error", result: error?.response}
      }
}

export const getData = async (url, headers, params) => {
  try{   
      const res = await axios.get(url,  {params:params, headers: headers, withCredentials: true, credentials: 'include' });
      // alert('Success: ' + res)
      return {error: "", result: res};
          
    }catch(error){
      //alert('Status: ' + JSON.stringify(error))
      // Handle token expiration
      if(handleAuthExpiry(error)){
        return {error: "error", result: error?.response}
      }
      reportRequestError(error, 'GET', url)
      /*if(error?.response?.status == 422){
        window.location.href='/login'
      }*/
      return {error: "error", result: error?.response}
    }
}

export const deleteData = async (url, headers, params) => {
  try{
          
      const res = await axios.delete(url, {params:params, headers: headers, withCredentials: true});
      //alert(JSON.stringify(res))
      return {error: "", result: res};
          
    }catch(error){
      //alert(JSON.stringify(error.response))
      // Handle token expiration
      if(handleAuthExpiry(error)){
        return {error: "error", result: error?.response}
      }
      reportRequestError(error, 'DELETE', url)
      if(error?.response?.status == 422){
        window.location.href='/login'
      }
      return {error: "error", result: error?.response}
    }
}

export const postDataWithForm = async (url, headers, formData) => {
  try {
    const res = await axios.post(url, formData, {
      headers: {
        ...(headers || {})
      },
      withCredentials: true
    })
    return { error: '', result: res }
  } catch (error) {
    if (handleAuthExpiry(error)) {
      return { error: 'error', result: error?.response }
    }
    reportRequestError(error, 'POST', url)
    return { error: 'error', result: error?.response }
  }
}
